import { render, staticRenderFns } from "./RegisterRedirect.vue?vue&type=template&id=4ca8caa0&"
import script from "./RegisterRedirect.vue?vue&type=script&lang=js&"
export * from "./RegisterRedirect.vue?vue&type=script&lang=js&"
import style0 from "./RegisterRedirect.vue?vue&type=style&index=0&id=4ca8caa0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports